import {connect} from 'react-redux';
import SupporterActionsBlock from '../../../components/blocks/supporter/SupporterActionsBlock';

const mapStateToProps = (state) => {
    return {
        supporterDetails: state.supporterDetails,
        supporterProject: state.supporterProject,
        printer: state.printer
    }
};

const SupporterActionsBlockContainer = connect(
    mapStateToProps,
    null
)(SupporterActionsBlock);

export default SupporterActionsBlockContainer;